var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsightBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00012207,
    width: 400,
    height: 400,
    rx: 32,
    fill: "#FFF7AC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_53950_4756",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 400,
    height: 401
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.00012207,
    width: 400,
    height: 400,
    rx: 32,
    fill: "#D4E0FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_53950_4756)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -86,
    cy: 400,
    r: 266,
    fill: "#FFE79B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470,
    cy: 20.0001,
    r: 215,
    fill: "#FFE79B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightBackground);
export default __webpack_public_path__ + "static/media/insight-background.4228f3df534f9ec4d0a2fe92294d2b52.svg";
export { ForwardRef as ReactComponent };